<template>
    <input type="hidden"
           :name="fieldName"
           :value="field" />
</template>

<script setup>

const props = defineProps({
    fieldName: {
        type: String,
        required: true
    },
    field: {
        type: [String, Number],
        default: null
    },
});

</script>

<style lang="scss" scoped></style>
